import Vue from 'vue'
import wysiwyg from 'vue-wysiwyg';
import 'vue-wysiwyg/dist/vueWysiwyg.css';

Vue.use(wysiwyg, {
    hideModules: {
        "justifyLeft": true,
        "justifyCenter": true,
        "justifyRight": true,
        "headings": true,
        "link": true,
        "code": true,
        "orderedList": true,
        "unorderedList": true,
        "image": true,
        "table": true,
        "removeFormat": false,
        "separator": true,
    },
});
